import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { select, Store } from '@ngrx/store';
import {
  GET_INTEGRATION_IMPORT_ERRORS,
  GET_INTEGRATION_IMPORTS,
  GetIntegrationImportErrorsAction,
  GetIntegrationImportErrorsFailureAction,
  GetIntegrationImportErrorsSuccessAction,
  GetIntegrationImportsAction,
  GetIntegrationImportsFailureAction,
  GetIntegrationImportsSuccessAction,
  SetIntegrationImportErrorsParamsAction,
  SetIntegrationImportsParamsAction
} from './integration-imports.actions';
import {
  getIntegrationImportErrorsParamsSelector,
  getIntegrationImportsParamsSelector
} from './integration-imports.reducer';
import {
  IntegrationImportErrorResult,
  IntegrationImportErrorsParams,
  IntegrationImportParams,
  IntegrationImportResult
} from './integration-imports.interface';
import { IntegrationsImportService } from './integration.import.service';
import { IState } from '../../shared/models/state';

@Injectable()
export class IntegrationImportsEffects {
  @Effect()
  getIntegrationImports$: Observable<any> = this.actions$.pipe(
    ofType(GET_INTEGRATION_IMPORTS),
    map((action: GetIntegrationImportsAction) => action.payload),
    withLatestFrom(this.store.pipe(select(getIntegrationImportsParamsSelector))),
    switchMap(([payload, params]: [IntegrationImportParams, IntegrationImportParams]) => {
      const completeParams: IntegrationImportParams = { ...params, ...payload };
      return this.integrationsImportService.fetch(completeParams).pipe(
        switchMap((response: IntegrationImportResult) => {
          return [
            new GetIntegrationImportsSuccessAction(response),
            new SetIntegrationImportsParamsAction(completeParams)
          ];
        }),
        catchError(error => of(new GetIntegrationImportsFailureAction(error)))
      );
    })
  );
  @Effect()
  getIntegrationImportErrors$: Observable<any> = this.actions$.pipe(
    ofType(GET_INTEGRATION_IMPORT_ERRORS),
    map((action: GetIntegrationImportErrorsAction) => action.payload),
    withLatestFrom(this.store.pipe(select(getIntegrationImportErrorsParamsSelector))),
    switchMap(([payload, params]: [IntegrationImportErrorsParams, IntegrationImportErrorsParams]) => {
      const completeParams: IntegrationImportErrorsParams = { ...params, ...payload };
      return this.integrationsImportService.fetchErrors(completeParams).pipe(
        switchMap((response: IntegrationImportErrorResult) => {
          return [
            new GetIntegrationImportErrorsSuccessAction(response),
            new SetIntegrationImportErrorsParamsAction(completeParams)
          ];
        }),
        catchError(error => of(new GetIntegrationImportErrorsFailureAction(error)))
      );
    })
  );

  constructor(
    private actions$: Actions,
    private integrationsImportService: IntegrationsImportService,
    private store: Store<IState>
  ) {}
}
